import { gql } from '@apollo/client';

export const RETRY_FAILED_HISTORICAL_IMPORT = gql`
    mutation RetryFailedHistoricalImport($id: ID!) {
        retryFailedHistoricalImport(id: $id) {
            id
            status
            scheduledFor
            fileName
            createdAt
        }
    }
`;
